import { BannerDto } from 'src/com/sixdee/crbtportal/core/dto/banner/bannerdto';
import { APIFeatures } from 'src/com/sixdee/crbtportal/core/util/apifeatures';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl, UIDataModel } from '../../../../toolkit/uicomponent';
import { APIModel, APIModelHandler } from '../../../../toolkit/uicomponentapimodel';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { BannerSearchListAPIModelImpl, BannerSearchListAPIModel } from '../bannerlist/bannersearchlistapimodel';
import { GetBannerDetailsListAPIModelImpl } from '../bannerlist/getbannerlistapimodel';
import { MusicboxBannerListAPIModelImpl } from '../bannerlist/musicboxbannerlistapimodel';
import { BannerCardCSSStyleImpl } from './bannercardcss';
import { BannerCardViewImpl } from './bannercardview';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { AudioPlayerWithProgress } from '../../../../toolkit/player/playerwithprogress/playerwithprogressimpl';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';


export interface BannerCardComponentProps extends UIComponentProps
{   
    audioPlayerWithProgress: AudioPlayerWithProgress;
    position: number;
    bannerDto:BannerDto;
    onBannerClick(bannerDto:BannerDto):void;
    startAutoPlay(): void;
    stopAutoPlay(): void;
}



export interface BannerCardComponentState extends UIComponentState
{
   
}

export interface BannerCardComponentHandler extends UIComponentHandler
{
    onBannerClick(): void;
    getBannerList(): void;
}

export class BannerCardComponent extends UIComponentImpl<BannerCardComponentProps, BannerCardComponentState, UIDataModel> implements BannerCardComponentHandler
{
    constructor(props: BannerCardComponentProps)
    {
        super(props);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new BannerCardViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new BannerCardCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return this.getBannerAPIModel(applicationContext, apiModelHandler);
    }

    componentWillUnmount()
    {
        this.props.audioPlayerWithProgress.unRegisterEvents();
    }

    // componentDidMount()
    // {
    //     (this.getView() as BannerCardViewImpl).setPlayerWithProgress();
    // }

    onBannerClick():void
    {
        this.props.onBannerClick(this.props.bannerDto);
    }

    getBannerList(): void {
        (this.getAPIModel() as BannerSearchListAPIModel).getListofBannerTones(
            this.props.bannerDto.getBannerOrder(), this.props.bannerDto.getType() , this.props.bannerDto.getSearchKey(),
        0, +this.props.context.getConfigurationSettings().getProperty("FETCH_LIMIT"));
    }
   
    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        console.log("------onSuccess: " );
       
          if((data as ToneDto[]).length === 1)
          {
            console.log("------onSuccess: " +  (data[0] as ToneDto).getToneUrl());
               (this.getView() as BannerCardViewImpl).startPlay(data[0] as ToneDto);
          }
          else
          {
            this.props.onBannerClick(this.props.bannerDto);
          }
       
    }
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as BannerCardViewImpl).onPlayStop();
        this.props.startAutoPlay();

        // (this.getView() as BannerCardViewImpl).getPlayerToneUrl(data as ToneDto);
 // view data[0]. and length >1 
 //method play 
    }
    private getBannerAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        if(this.props.bannerDto.getType() === this.getContext().getResources().getString(Strings.manual) || this.props.bannerDto.getType() === this.getContext().getResources().getString(Strings.prebooking))
        {
            return new GetBannerDetailsListAPIModelImpl(applicationContext, apiModelHandler);
        }
        else if(this.props.bannerDto.getType() === this.getContext().getResources().getString(Strings.music_box))
        {
            return new MusicboxBannerListAPIModelImpl(applicationContext, apiModelHandler);
        }
        else
        {
            return new BannerSearchListAPIModelImpl(applicationContext, apiModelHandler);
        }
    }
   
    // protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    // {
    //      return new ToneCardAPIModelImpl(applicationContext, apiModelHandler);
    // }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/banner/bannercard/bannercardcomponent.tsx